<template>
    <div style="height:45vh;">
      <div class="control-row">
        <content-loader height="20" primary-color="#F2F7FD" secondary-color="#E0EDFB">
          <rect y="0" x="0" width="100%" height="100"/>
        </content-loader>
      </div>
      <div class="code-wrapper">
        <div class="code-row">
          <content-loader height="250" primary-color="#F2F7FD" secondary-color="#E0EDFB">
            <rect y="10" x="0" width="7" height="7"/><rect y="10" x="12" width="20%" height="7"/>
            <rect y="20" x="0" width="7" height="7"/>
            <rect y="30" x="0" width="7" height="7"/><rect y="30" x="12" width="40%" height="7"/>
            <rect y="40" x="0" width="7" height="7"/><rect y="40" x="12" width="40%" height="7"/>
            <rect y="50" x="0" width="7" height="7"/><rect y="50" x="12" width="50%" height="7"/>
            <rect y="60" x="0" width="7" height="7"/><rect y="60" x="12" width="60%" height="7"/>
            <rect y="70" x="0" width="7" height="7"/><rect y="70" x="12" width="20%" height="7"/>
          </content-loader>
        </div>
      </div>
    </div>
</template>

<script>
    import { ContentLoader } from "vue-content-loader";

    export default {
        name: "SolutionEditorLoadingIndicator",
        components: { ContentLoader },
        props: {height: {type: Number, default: 600}},
    };
</script>

<style scoped>
    .control-row, .code-wrapper {
      margin: 1rem 1rem 1rem 0.5rem;
    }
</style>